<template>
  <div class="min-h-full">
    <div class="bg-primary-dark">
      <Navbar />
    </div>
    <div class="min-h-full">
      <router-view>
      </router-view>
    </div>
    <div v-if="parent">
      <Helper :context="parent" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const parent = computed(() => store.getters['context/context']?.id ?? null);
const mount = onBeforeMount(() => store.dispatch('context/setup'));
</script>
